import React from "react";
import styled from "styled-components/macro";
import { Modal } from "./Modal";

interface NotificationProps {
  setTimer: () => void;
  resetTimer: () => void;
}

export const Notification = (props: NotificationProps) => {
  return (
    <Container>
      <Modal setTimer={props.setTimer} resetTimer={props.resetTimer} />
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  width: 100%;
`;
